// ===== Packages =====

import React, {
    useState,
    useEffect,
}                                               from 'react';
import styled                                   from 'styled-components';
import { useSelected }                          from 'slate-react';

// ===== Enums =====

import {
    ZOOM_LEVEL,
}                                               from '../elements/enums';
import {
    IZoomLevelItem,
}                                               from '../../../interfaces';

BottomBuffer.defaultProps = {
    currentZoomLevel: null,
};
interface Props {
    height: number,
    adjustSelectionAroundBottomBuffer: () => void,
    currentZoomLevel?: IZoomLevelItem | null,
    children: React.ReactElement,
    attributes: any,
}
function BottomBuffer({
    height,
    children,
    attributes,
    currentZoomLevel,
    adjustSelectionAroundBottomBuffer,
}: Props): JSX.Element {
    // ===== State =====

    const selected = useSelected();
    const [currentBufferHeight, setCurrentBufferHeight] = useState<number>(height);

    // ===== Side Effects =====

    useEffect(() => {
        if (selected) {
            adjustSelectionAroundBottomBuffer();
        }
    }, [selected]);

    useEffect(() => {
        if (
            currentZoomLevel
            && currentZoomLevel.level !== ZOOM_LEVEL.five
            && currentBufferHeight !== 0
        ) {
            setCurrentBufferHeight(0);
        } else if (
            currentZoomLevel
            && currentZoomLevel.level === ZOOM_LEVEL.five
            && currentBufferHeight !== height
        ) {
            setCurrentBufferHeight(height);
        }
    }, [currentZoomLevel]);

    return (
        <Container
            {...attributes}
            height={currentBufferHeight}
            contentEditable={false}
        >
            {children}
        </Container>
    );
}

// ===== Styled Components =====

interface ContainerProps {
    height: number,
}
const Container = styled.div<ContainerProps>`
    width: 100%;
    height: ${({ height }) => `${height}px`};
    margin: 0;
    padding: 0;
`;

export default BottomBuffer;
